import React from 'react'
import { cn } from '../utils/ui'

/**
 * Simplified RichText component for rendering text content
 * This is a simplified version that handles basic text formatting
 */
export default function RichText({ 
  data, 
  className, 
  enableProse = true, 
  enableGutter = true,
  ...props 
}) {
  // If data is a string, render it directly
  if (typeof data === 'string') {
    return (
      <div
        className={cn(
          'payload-richtext',
          {
            container: enableGutter,
            'max-w-none': !enableGutter,
            'mx-auto prose md:prose-md dark:prose-invert': enableProse,
          },
          className,
        )}
        {...props}
      >
        {data.split('\n\n').map((paragraph, index) => {
          const lines = paragraph.split('\n')
          const firstLine = lines[0]?.trim()
          const isSectionTitle = firstLine && firstLine.endsWith(':')
          const isNewSection = index > 0 && isSectionTitle
          const sectionSpacing = isNewSection ? 'mt-8' : ''
          
          return (
            <p
              key={index}
              className={cn(
                'mb-2 last:mb-0 leading-snug',
                sectionSpacing
              )}
            >
              {lines.map((line, lineIndex) => {
                const trimmedLine = line.trim()
                const isTitle = trimmedLine && trimmedLine.endsWith(':')
                
                return (
                  <React.Fragment key={lineIndex}>
                    {isTitle ? (
                      <span className="text-xl sm:text-2xl font-bold text-white block mb-1">
                        {line}
                      </span>
                    ) : (
                      <>{line}</>
                    )}
                    {lineIndex < lines.length - 1 && <br />}
                  </React.Fragment>
                )
              })}
            </p>
          )
        })}
      </div>
    )
  }

  // If data has a text property, use that
  if (data && data.text) {
    return (
      <div
        className={cn(
          'payload-richtext',
          {
            container: enableGutter,
            'max-w-none': !enableGutter,
            'mx-auto prose md:prose-md dark:prose-invert': enableProse,
          },
          className,
        )}
        {...props}
      >
        {data.text.split('\n\n').map((paragraph, index) => {
          const lines = paragraph.split('\n')
          const firstLine = lines[0]?.trim()
          const isSectionTitle = firstLine && firstLine.endsWith(':')
          const isNewSection = index > 0 && isSectionTitle
          const sectionSpacing = isNewSection ? 'mt-8' : ''
          
          return (
            <p
              key={index}
              className={cn(
                'mb-2 last:mb-0 leading-snug',
                sectionSpacing
              )}
            >
              {lines.map((line, lineIndex) => {
                const trimmedLine = line.trim()
                const isTitle = trimmedLine && trimmedLine.endsWith(':')
                
                return (
                  <React.Fragment key={lineIndex}>
                    {isTitle ? (
                      <span className="text-xl sm:text-2xl font-bold text-white block mb-1">
                        {line}
                      </span>
                    ) : (
                      <>{line}</>
                    )}
                    {lineIndex < lines.length - 1 && <br />}
                  </React.Fragment>
                )
              })}
            </p>
          )
        })}
      </div>
    )
  }

  // Fallback for other data structures
  return (
    <div
      className={cn(
        'payload-richtext',
        {
          container: enableGutter,
          'max-w-none': !enableGutter,
          'mx-auto prose md:prose-md dark:prose-invert': enableProse,
        },
        className,
      )}
      {...props}
    >
      {JSON.stringify(data)}
    </div>
  )
}
